import {Component, EventEmitter, inject, Output} from '@angular/core';
import {ButtonPadraoComponent} from '../../shared/components/button-padrao/button-padrao.component';
import {DomSanitizer} from '@angular/platform-browser';
import {ImagensUsuarioPerfilModel} from '../../shared/model/usuario/imagens-usuario-perfil.model';

@Component({
  selector: 'app-balao-sugestao',
  standalone: true,
  imports: [
    ButtonPadraoComponent
  ],
  templateUrl: './balao-sugestao.component.html',
  styleUrl: './balao-sugestao.component.css'
})
export class BalaoSugestaoComponent {

  imgUsuarioPerfil: ImagensUsuarioPerfilModel = new ImagensUsuarioPerfilModel();
  @Output() envioImg = new EventEmitter<ImagensUsuarioPerfilModel>();

  private readonly domSanitizer = inject(DomSanitizer);

  selecionarFotoUsuario(event: any) {
    const reader = new FileReader();
    reader.readAsDataURL(event.target?.files[0]);
    reader.onload = () => {
      if(reader.result) {
        this.imgUsuarioPerfil.imgUsuario = this.domSanitizer.bypassSecurityTrustUrl(reader.result.toString());
        this.imgUsuarioPerfil.imgBase64 = reader.result.toString().split(';base64,')[1];
        this.imgUsuarioPerfil.extensaoImg = reader.result.toString().split(';base64,')[0].split('/')[1];
        this.envioImg.emit(this.imgUsuarioPerfil);
      }
    };
  }

}
